import { PenLine } from "lucide-react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { useFieldCuration } from "./curated-fields-context";

export const CURATED_TOOLTIP =
  "Edited by a curator — refreshes ask before changing it";

/**
 * A non-interactive marker beside a field a curator has edited. Info only —
 * there is no unlock action; a refresh that would overwrite this field asks
 * a curator first instead.
 */
export function CuratedBadge({ fieldKey }: { fieldKey: string }) {
  const { curated } = useFieldCuration(fieldKey);
  if (!curated) return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            role="img"
            aria-label="Curated field"
            className="ml-1 inline-flex align-middle text-amber-600"
          >
            <PenLine className="h-3.5 w-3.5" aria-hidden="true" />
          </span>
        </TooltipTrigger>
        <TooltipContent>{CURATED_TOOLTIP}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
